import * as PIXI from 'pixi.js';
import * as PrefabManager from '../PrefabManager';
import {
    game
} from "../../Game";
import {
    Settings
} from '../../Settings';
import * as emitterManager from '../../utils/EmitterManager';
import * as AudioManager from '../../utils/AudioManager';
import { clampAngleToRange, rotateVectorAroundPoint } from '../../b2Editor/utils/extramath';
import { editorSettings } from '../../b2Editor/utils/editorSettings';
import { b2CloneVec2, b2DotVV, b2SubVec2 } from '../../../libs/debugdraw';
import { generateGoreParticles } from '../../utils/GenerateGoreParticles';
import * as PhysicsParticleEmitter from '../../utils/PhysicsParticleEmitter';
import { simulationTime } from '../../utils/SimulationClock';
import { recordReplayEvent } from '../../utils/ReplayExportJob';
import { HITSTOP_FRAMES, requestHitstop } from '../../utils/Hitstop';
import { spillIntestines } from '../misc/Intestines';
import { prewarmGore, pumpGorePrewarm } from '../../utils/gore/goreChunks';
import { endSpray, pulseSpray, startSpray } from '../../utils/gore/goreSpray';
const vec1 = new Box2D.b2Vec2(0, 0);
const vec2 = new Box2D.b2Vec2(0, 0);

const { getPointer, NULL } = Box2D;

const sprayAnchor = new Box2D.b2Vec2(0, 0);
const copyAnchor = anchor => ({x: anchor.x, y: anchor.y});

export class Humanoid extends PrefabManager.basePrefab {
    static TIME_EYES_CLOSE = 3000;
    static TIME_EYES_OPEN = 3100;
    static TIME_EXPRESSION_PAIN = 500;
    static TIME_EXPRESSION_SPECIAL = 1000;
    static TIME_EXPRESSION_SPECIAL_MIN = 3000;
    static TIME_EXPRESSION_SPECIAL_MAX = 15000;
    static EXPRESSION_IDLE = 'Idle';
    static EXPRESSION_SPECIAL = 'Special';
    static EXPRESSION_PAIN = 'Pain';

    static JSON_ADULT = '{"objects":[[0,-0.101,1.398,-0.069,".character#Humanoid , .flesh","thigh_left",0,["#999999"],["#000"],[0],false,true,[[{"x":-0.202,"y":-1.031},{"x":0.196,"y":-1.044},{"x":0.17,"y":1.038},{"x":-0.164,"y":1.038}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[0,0.132,3.393,-0.087,".character#Humanoid , .flesh","leg_left",1,["#999999"],["#000"],[0],false,true,[[{"x":-0.161,"y":-0.912},{"x":0.161,"y":-0.925},{"x":0.084,"y":0.912},{"x":-0.084,"y":0.925}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[1,-3.298,42.261,-0.069,"","",2,"Normal_Thigh0000",0,0.413,-2.367,0,true,"#FFFFFF",1,1,1,0,0,0,true],[0,0.281,4.556,0.14,".character#Humanoid , .flesh","feet_left",3,["#999999"],["#000"],[0],false,true,[[{"x":-0.353,"y":-0.233},{"x":0.359,"y":0},{"x":0.359,"y":0.123},{"x":-0.365,"y":0.111}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[1,3.75,101.822,-0.087,"","",4,"Normal_Leg0000",1,0.199,-3.142,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,-0.182,73.189,-0.558,".character#Humanoid","leg_left_joint",5,1,0,0,false,false,1,10,true,0,-149,0,0,0,0],[1,9.149,135.34,0.14,"","",6,"Normal_Feet0000",3,1.515,1.214,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,4.087,129.062,-0.558,".character#Humanoid","feet_left_joint",7,3,1,0,false,false,1,10,true,0,0,0,0,0,0],[0,-0.025,-1.823,-0.087,".character#Humanoid , .flesh","shoulder_left",8,["#999999"],["#000"],[0],false,true,[[{"x":-0.185,"y":-0.859},{"x":0.193,"y":-0.842},{"x":0.111,"y":0.851},{"x":-0.119,"y":0.851}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[0,0.267,-0.321,-0.314,".character#Humanoid , .flesh","arm_left",9,["#999999"],["#000"],[0],false,true,[[{"x":-0.136,"y":-0.686},{"x":0.144,"y":-0.703},{"x":0.127,"y":0.694},{"x":-0.136,"y":0.694}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[1,-0.175,-54.652,-0.087,"","",10,"Normal_Shoulder0000",8,0.573,-0.161,0,true,"#FFFFFF",1,1,1,0,0,0,true],[1,8.261,-9.47,-0.314,"","",11,"Normal_Arm0000",9,0.298,-0.894,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,2.477,-31.084,-0.279,".character#Humanoid","arm_left_joint",12,9,8,0,false,false,1,10,true,152,0,0,0,0,0],[0,0.402,0.541,-0.157,".character#Humanoid , .flesh","hand_left",13,["#999999"],["#000"],[0],false,true,[[{"x":0,"y":0},{"x":0,"y":0}]],[1],7,[7.513],"",[1],true,false,false,[0.5],[0.2]],[1,10.274,16.109,-0.157,"","",14,"Normal_Hand0000",13,1.798,2.91,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,14.99,8.191,1.344,".character#Humanoid","hand_left_joint",15,13,9,0,false,false,1,10,true,60,-60,0,0,0,0],[0,-0.372,0.236,-0.279,".character#Humanoid , .flesh","belly",16,["#999999"],["#000"],[0],false,true,[[{"x":0,"y":0},{"x":0,"y":0}]],[1],7,[14.181],"",[1],true,false,false,[0.5],[0.2]],[0,-0.255,-4.116,-0.279,".character#Humanoid , .flesh","head",17,["#999999"],["#000"],[0],false,true,[[{"x":0,"y":0},{"x":0,"y":0}]],[1],7,[30.393],"",[1],true,false,false,[0.5],[0.2]],[0,-0.282,-1.561,0.07,".character#Humanoid , .flesh","body",18,["#999999"],["#000"],[0],false,true,[[{"x":-0.537,"y":1.202},{"x":-0.432,"y":-1.37},{"x":-0.15,"y":-1.828},{"x":0.132,"y":-1.793},{"x":0.555,"y":-1.123},{"x":0.555,"y":1.308},{"x":0.097,"y":1.801},{"x":-0.22,"y":1.801}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[1,-10.005,-1.6,-0.079,"","",19,"Normal_Belly0000",16,8.747,1.158,-0.2,false,"#FFFFFF",1,1,1,0,0,0,true],[2,-3.345,14.084,-0.279,".character#Humanoid","thigh_left_joint",20,0,16,0,false,false,1,10,true,142,-16,0,0,0,0],[1,-7.394,-50.875,0.07,"","",21,"Normal_Core0000",18,4.169,1.384,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,-2.531,-77.904,-0.279,".character#Humanoid","shoulder_left_joint",22,8,18,0,false,false,1,10,true,180,-19,0,0,0,0],[1,-6.184,-126.087,-0.279,"","",23,"Normal_Head_Idle0000",17,2.99,0.785,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,-3.244,-95.724,-0.279,".character#Humanoid","head_joint",24,17,18,0,false,false,1,10,true,58,-64,0,0,0,0],[0,-0.298,1.448,-0.017,".character#Humanoid , .flesh","thigh_right",25,["#999999"],["#000"],[0],false,true,[[{"x":-0.202,"y":-1.031},{"x":0.196,"y":-1.044},{"x":0.17,"y":1.038},{"x":-0.164,"y":1.038}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[0,-0.196,3.414,-0.069,".character#Humanoid , .flesh","leg_right",26,["#999999"],["#000"],[0],false,true,[[{"x":-0.161,"y":-0.912},{"x":0.161,"y":-0.925},{"x":0.084,"y":0.912},{"x":-0.084,"y":0.925}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[0,-0.063,-4.29,-0.279,".character#Humanoid","eye_left",27,["#999999"],["#000"],[0],false,true,[[{"x":0,"y":0},{"x":0,"y":0}]],[1],7,[7.534],"",[1],true,false,false,[0.5],[0.2]],[1,-9.221,43.728,-0.017,"","",28,"Normal_Thigh0000",25,0.413,-2.367,0,true,"#FFFFFF",1,1,1,0,0,0,true],[1,-6.066,102.425,-0.069,"","",29,"Normal_Leg0000",26,0.199,-3.142,0,true,"#FFFFFF",1,1,1,0,0,0,true],[1,-2.956,-128.368,-0.279,"","",30,"Normal_Eye0000",27,0.561,1.264,0,null,"#FFFFFF",1,1,1,0,0,0,true],[2,-7.92,75.367,-0.279,".character#Humanoid","leg_right_joint",31,26,25,0,false,false,1,10,true,0,-149,0,0,0,0],[0,0.046,4.564,0,".character#Humanoid , .flesh","feet_right",32,["#999999"],["#000"],[0],false,true,[[{"x":-0.353,"y":-0.233},{"x":0.359,"y":0},{"x":0.359,"y":0.123},{"x":-0.365,"y":0.111}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[1,1.901,135.511,0,"","",33,"Normal_Feet0000",32,1.515,1.214,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,-4.429,129.892,-0.453,".character#Humanoid","feet_right_joint",34,32,26,0,false,false,1,10,true,0,0,0,0,0,0],[0,-0.143,-1.648,-0.104,".character#Humanoid , .flesh","shoulder_right",35,["#999999"],["#000"],[0],false,true,[[{"x":-0.185,"y":-0.859},{"x":0.193,"y":-0.842},{"x":0.111,"y":0.851},{"x":-0.119,"y":0.851}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[0,0.097,-0.143,-0.192,".character#Humanoid , .flesh","arm_right",36,["#999999"],["#000"],[0],false,true,[[{"x":-0.136,"y":-0.686},{"x":0.144,"y":-0.703},{"x":0.127,"y":0.694},{"x":-0.136,"y":0.694}]],[1],7,[null],"",[1],true,false,false,[0.5],[0.2]],[0,0.628,-4.506,-0.279,".character#Humanoid","eye_right",37,["#999999"],["#000"],[0],false,true,[[{"x":0,"y":0},{"x":0,"y":0}]],[1],7,[7.534],"",[1],true,false,false,[0.5],[0.2]],[1,16.878,-133.748,-0.279,"","",38,"Normal_Eye0000",37,0.561,1.264,0,null,"#FFFFFF",1,1,1,0,0,0,true],[2,19,-135,-0.279,".character#Humanoid","eye_right_joint",39,37,17,0,false,false,1,10,true,0,0,0,0,0,0],[1,-3.729,-49.407,-0.104,"","",40,"Normal_Shoulder0000",35,0.573,-0.161,0,true,"#FFFFFF",1,1,1,0,0,0,true],[1,3.143,-4.084,-0.192,"","",41,"Normal_Arm0000",36,0.298,-0.894,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,-1.292,-25.07,-0.279,".character#Humanoid","arm_right_joint",42,36,35,0,false,false,1,10,true,152,0,0,0,0,0],[0,0.105,0.751,-0.226,".character#Humanoid , .flesh","hand_right",43,["#999999"],["#000"],[0],false,true,[[{"x":0,"y":0},{"x":0,"y":0}]],[1],7,[7.513],"",[1],true,false,false,[0.5],[0.2]],[1,1.348,22.526,-0.226,"","",44,"Normal_Hand0000",43,1.798,2.91,0,true,"#FFFFFF",1,1,1,0,0,0,true],[2,5.692,15.019,1.519,".character#Humanoid","hand_right_joint",45,43,36,0,false,false,1,10,true,60,-60,0,0,0,0],[2,-6.55,-71.951,-0.279,".character#Humanoid","shoulder_right_joint",46,35,18,0,false,false,1,10,true,180,-19,0,0,0,0],[2,-1.9,-129,-0.279,".character#Humanoid","eye_left_joint",47,27,17,0,false,false,1,10,true,0,0,0,0,0,0],[2,-10.891,1.001,-0.279,".character#Humanoid","belly_joint",48,18,16,0,false,false,1,10,true,10,-10,0,0,0,0],[2,-9.878,15.503,-0.279,".character#Humanoid","thigh_right_joint",49,25,16,0,false,false,1,10,true,142,-16,0,0,0,0]]}';

    constructor(target) {
        super(target);
        this.life = 300;
        this.flipped = false;
        this.mouthTextureName = 'Mouth';
        this.mouthPos = {x:41, y:59};
        this.releaseImmune = 0;
        this.skin = 0;
        this.mask = 1;
        this.maskSprite = null;
        this.ignoreJointDamage = false;
        this.jointMaxForces = [1300000, 1300000, 1300000, 1300000];
        this.jointMaxTorque = 600;
        this.invincible = false;
        this.dollMode = false;
    }

    postConstructor(){
        if(!this.mouth){
            this.mouth = new PIXI.Sprite(PIXI.Texture.from(`${this.mouthTextureName}_Idle0000`))
            this.mouth.x = this.mouthPos.x; // magic numbers
            this.mouth.y = this.mouthPos.y;
            this.lookupObject[Humanoid.BODY_PARTS.HEAD].myTexture.addChild(this.mouth);
        }
    }

    init() {
        super.init();
        this.patchJointAngles();
        this.stabalizeJoints();
        this.eyesTimer = 0.0;
        this.collisionUpdates = [];

        this.bloodSprays = [];

        this.alive = true;
        this.bleedTimer = -1;

        this.expression = Humanoid.EXPRESSION_IDLE;
        this.expressionTimer = 0;
        this.targetExpressionTimer = 0;
        this.specialExpressionTimer = 0;
        this.targetSpecialExpressionTimer = Humanoid.TIME_EXPRESSION_SPECIAL_MIN + (Humanoid.TIME_EXPRESSION_SPECIAL_MAX-Humanoid.TIME_EXPRESSION_SPECIAL_MIN) * Math.random();

        this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT].noDamage = true;
        this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT].noDamage = true;
        this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT].noDamage = true;
        this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT].noDamage = true;

        this.vains = [];
        this.vainJoints = [];

        game.editor.setBodyCollision(this.lookupObject.eye_left, [2]);
        game.editor.setBodyCollision(this.lookupObject.eye_right, [2]);

        var i;
        for (i = 0; i < this.lookupObject._bodies.length; i++) {
            var body = this.lookupObject._bodies[i];
            if (body.mySprite.data.groups.indexOf('.flesh') >= 0) {

                body.isFlesh = true;
                body.isHumanoid = true;
                body.bloodSkin = this.skin;

                game.editor.prepareBodyForDecals(body);

                var texture = body.myTexture;
                //fix gore for Skin2, Skin3 etc
                var frameNumIndex = texture.data.textureName.indexOf('00');
                var fleshName = texture.data.textureName.substr(0, frameNumIndex);

                if (fleshName.indexOf('Head') > 0) fleshName = fleshName.substr(0, fleshName.indexOf('_')) + "_Head";

                var sprite = new PIXI.Sprite(PIXI.Texture.from(fleshName + "_Flesh0000"));
                texture.myFlesh = sprite;
                texture.addChildAt(sprite, 0);
            }
        }
        prewarmGore(this.lookupObject._bodies.filter(body => body.isFlesh), !this.noGoreParticles);
    }

    setExpression(expression){
        if(this.expression === expression) return;
        if(!this.lookupObject.head || this.mouth.destroyed) return;

        const textureName = this.mouth.texture.label;
        const textureSkin = textureName.substr(textureName.length - 4);
        this.mouth.texture = PIXI.Texture.from(`${this.mouthTextureName}_${expression}${textureSkin}`);

        this.expressionTimer = 0;

        if(expression === Humanoid.EXPRESSION_PAIN){
            // close eyes as well
            this.eyesTimer = Humanoid.TIME_EYES_CLOSE-1;
            this.targetExpressionTimer = Humanoid.TIME_EXPRESSION_PAIN;
        }else if(expression === Humanoid.EXPRESSION_SPECIAL){
            this.targetExpressionTimer = Humanoid.TIME_EXPRESSION_PAIN;
            this.targetSpecialExpressionTimer = Humanoid.TIME_EXPRESSION_SPECIAL_MIN + (Humanoid.TIME_EXPRESSION_SPECIAL_MAX-Humanoid.TIME_EXPRESSION_SPECIAL_MIN) * Math.random();
            this.specialExpressionTimer = 0;
        }
        this.expression = expression;

    }

    setSkin(skin){
        this.skin = skin;
        const targetFrame = String(skin).padStart(4, '0');
        for (let i = 0; i < this.lookupObject._bodies.length; i++) {
            const body = this.lookupObject._bodies[i];
            body.bloodSkin = skin;

            let targetTextureName = body.myTexture.data.textureName.substr(0, body.myTexture.data.textureName.length-4);
            let targetTexture = targetTextureName+targetFrame;

            body.myTexture.data.textureName = targetTexture;
            body.myTexture.originalSprite.texture = PIXI.Texture.from(targetTexture);
        }
        this.mouth.texture = PIXI.Texture.from(`${this.mouthTextureName}_Idle${targetFrame}`);
    }

    setMask(mask){
        if(mask){
            const body = this.lookupObject['eye_right'];

            this.maskSprite = new PIXI.Sprite(PIXI.Texture.from(`masks${(mask-1).toString().padStart(4, '0')}`));

            body.myTexture.addChild(this.maskSprite);

            this.maskSprite.x = -62.4; // offset to position on head correctly
            this.maskSprite.y = -34.6;
        }
    }

    dropMask(){
        if(this.maskSprite){
            const body = this.lookupObject['eye_right'];
            const head = this.lookupObject['head'];

            if(body && head){
                const childIndex = body.myTexture.parent.getChildIndex(body.myTexture);
                const maskTextureName = this.maskSprite.texture.label;

                this.maskSprite.destroy();

                PhysicsParticleEmitter.emit([maskTextureName], body.GetPosition(), 1, 5, 20, false, undefined, body.GetAngle(), undefined, head.GetLinearVelocity(), childIndex, false);
            }

            this.maskSprite = null;
        }
    }

    flip(){
        this.flipped = !this.flipped;
        game.editor.mirrorPrefab(this, 'body');
    }

    isPortalTransitActive(){
        return !!this.lookupObject?._bodies?.some(body =>
            body && !body.destroyed && body._portalTransitCandidate
        );
    }

    update() {
        super.update();
        pumpGorePrewarm();

        if(this.dollMode) return;

        if (PrefabManager.timerReady(this.eyesTimer, Humanoid.TIME_EYES_CLOSE, true) || !this.alive) {
            if (this.lookupObject.eye_left && !this.lookupObject.eye_left.snapped){
                const textureIndex = this.lookupObject.eye_left.myTexture.data.textureName.substr(this.lookupObject.eye_left.myTexture.data.textureName.length-4);
                const baseTextureName = this.lookupObject.eye_left.myTexture.data.textureName.split(textureIndex)[0];
                this.lookupObject.eye_left.myTexture.originalSprite.texture = PIXI.Texture.from(`${baseTextureName}_Closed${textureIndex}`);
            }
            if (this.lookupObject.eye_right && !this.lookupObject.eye_right.snapped){
                const textureIndex = this.lookupObject.eye_right.myTexture.data.textureName.substr(this.lookupObject.eye_right.myTexture.data.textureName.length-4);
                const baseTextureName = this.lookupObject.eye_right.myTexture.data.textureName.split(textureIndex)[0];
                this.lookupObject.eye_right.myTexture.originalSprite.texture = PIXI.Texture.from(`${baseTextureName}_Closed${textureIndex}`);
            }
        } else if (PrefabManager.timerReady(this.eyesTimer, Humanoid.TIME_EYES_OPEN, false)) {
            if (this.lookupObject.eye_left) this.lookupObject.eye_left.myTexture.originalSprite.texture = PIXI.Texture.from(this.lookupObject.eye_left.myTexture.data.textureName);
            if (this.lookupObject.eye_right) this.lookupObject.eye_right.myTexture.originalSprite.texture = PIXI.Texture.from(this.lookupObject.eye_right.myTexture.data.textureName);
            this.eyesTimer = -game.editor.deltaTime;
        }

        if (PrefabManager.timerReady(this.expressionTimer, this.targetExpressionTimer, true) && this.alive) {
            this.setExpression(Humanoid.EXPRESSION_IDLE);
        }

        if (PrefabManager.timerReady(this.specialExpressionTimer, this.targetSpecialExpressionTimer, true) && this.alive) {
            this.setExpression(Humanoid.EXPRESSION_SPECIAL);
        }

        const portalTransitActive = this.isPortalTransitActive();

        if(this.teleportTicks) this.teleportTicks--;
        if(portalTransitActive) this.processBodySeparation(true);
        // no damage when teleporting for x ticks;
        if(!game.tutorialMode && !this.teleportTicks && !portalTransitActive){
            this.processJointDamage();
            this.processBodySeparation();
        }

        if (this.collisionUpdates.length > 0) {
            this.doCollisionUpdate(this.collisionUpdates[0]);
            this.collisionUpdates.shift();
            this.checkLimbs();
        }
        if(!game.tutorialMode && !this.teleportTicks && !portalTransitActive){
            // Collision processing can create a new wound. Initialize/update it
            // immediately so the emitter manager sees its current anchor in the
            // same frame instead of starting one frame behind the detached limb.
            this.processBloodSprays();
        }
        this.eyesTimer += game.editor.deltaTime;
        this.expressionTimer += game.editor.deltaTime;
        this.specialExpressionTimer += game.editor.deltaTime;

        if (this.bleedTimer >= 0) {
            if (this.bleedTimer == 0) {
                this.die();
            }
            this.bleedTimer--;
        }
        if(this.life<=0 && this.bleedTimer<0){
            this.bleedTimer = 0;
        }
    }
    die(){
        if(this.alive){
            const body = [this.lookupObject.head, this.lookupObject.body].find(body => body && !body.destroyed);
            recordReplayEvent('death', {who: this.replayActor()}, body?.GetPosition());
        }
        this.alive = false;
    }
    replayActor(){
        return game.character === this ? 'player' : 'npc';
    }
    processJointDamage() {
        const jointsToAnalyse = ['leg_left', 'leg_right', 'arm_left', 'arm_right'];
        if(this.ignoreJointDamage || this.invincible) return;

        for (let i = 0; i < jointsToAnalyse.length; i++) {
            const part = jointsToAnalyse[i];
            const targetJoint = this.lookupObject[part + '_joint'];
            if(
                !targetJoint ||
                targetJoint.destroyed ||
                !this.lookupObject[part] ||
                simulationTime() < this.releaseImmune
            ) continue;

            const reactionForce = targetJoint
                .GetReactionForce(1 / Settings.physicsTimeStep)
                .LengthSquared();
            const reactionTorque = targetJoint.GetReactionTorque(1 / Settings.physicsTimeStep);

            if(
                reactionForce > this.jointMaxForces[i] ||
                Math.abs(reactionTorque) > this.jointMaxTorque
            ) {
                this.collisionUpdates.push({
                    type: Humanoid.GORE_SNAP,
                    target: part,
                });
            }
        }

        // The waist carries the whole upper body and takes several times a
        // knee's force in the same crash, so it tears at eight times the knee's limit.
        const waistJoint = this.lookupObject[Humanoid.BODY_PARTS.BELLY + '_joint'];
        if(
            waistJoint &&
            !waistJoint.destroyed &&
            this.lookupObject[Humanoid.BODY_PARTS.BELLY] &&
            simulationTime() >= this.releaseImmune &&
            waistJoint.GetReactionForce(1 / Settings.physicsTimeStep).LengthSquared() > this.jointMaxForces[0] * 8
        ) {
            this.collisionUpdates.push({
                type: Humanoid.GORE_SNAP,
                target: Humanoid.BODY_PARTS.BELLY,
            });
        }
    }

    processBloodSprays(){

        if(!Settings.goreEnabled){
            this.bloodSprays.forEach(endSpray);
            this.bloodSprays.length = 0;
        }

        for(let i = 0; i<this.bloodSprays.length; i++){
            const spray = this.bloodSprays[i];
            if(!spray.pulse) startSpray(spray);
            if(spray.body && !spray.body.destroyed){
                sprayAnchor.Set(spray.anchor.x, spray.anchor.y);
                const spawnPos = spray.body.GetWorldPoint(sprayAnchor);
                if(!spray.hasWoundDirection){
                    const localCenter = spray.body.GetLocalCenter();
                    spray.localWoundOffsetX = spray.anchor.x - localCenter.x;
                    spray.localWoundOffsetY = spray.anchor.y - localCenter.y;
                    if(
                        spray.localWoundOffsetX * spray.localWoundOffsetX +
                        spray.localWoundOffsetY * spray.localWoundOffsetY > 0.000001
                    ){
                        spray.angle = Math.atan2(spray.localWoundOffsetY, spray.localWoundOffsetX);
                    }
                    spray.hasWoundDirection = true;
                }
                const bodyAngle = spray.body.GetAngle();
                const cosBodyAngle = Math.cos(bodyAngle);
                const sinBodyAngle = Math.sin(bodyAngle);
                const woundOffsetX = spray.localWoundOffsetX * cosBodyAngle - spray.localWoundOffsetY * sinBodyAngle;
                const woundOffsetY = spray.localWoundOffsetX * sinBodyAngle + spray.localWoundOffsetY * cosBodyAngle;
                const woundAngle = bodyAngle + spray.angle;

                 if(!spray.initialized){
                     spray.emitter = emitterManager.playOnceEmitter(
                         "bloodSpray",
                         spray.body,
                         spawnPos,
                         woundAngle * game.editor.RAD2DEG
                     );
                     if(!spray.emitter) spray.time = 0; // if we receive no particle emitter destroy me right away
                     spray.initialized = true;
                 } else if(spray.emitter){
                    spray.emitter.spawnPos.set(spawnPos.x * Settings.PTM, spawnPos.y * Settings.PTM);
                 }
                 if(spray.emitter){
                    // Aim through the open cut surface instead of assuming every
                    // body part has the same local axes. This is especially
                    // visible at the neck, where the head and torso must spray in
                    // opposite directions. Particles also inherit the wound's
                    // linear and angular motion so a fast ragdoll cannot leave a
                    // misleading backwards jet behind it.
                    spray.emitter.rotation = woundAngle * game.editor.RAD2DEG + pulseSpray(spray, spray.emitter, game.editor.deltaTime);
                    const linearVelocity = spray.body.GetLinearVelocity();
                    const angularVelocity = spray.body.GetAngularVelocity();
                    spray.emitter.setSpawnVelocity(
                        (linearVelocity.x - angularVelocity * woundOffsetY) * Settings.PTM,
                        (linearVelocity.y + angularVelocity * woundOffsetX) * Settings.PTM
                    );
                 }
            }else if(spray.emitter){
                spray.emitter.spawnPos.set(-editorSettings.worldSize.width, -editorSettings.worldSize.height);
                spray.emitter.setSpawnVelocity();
            }

            spray.time -= game.editor.deltaTime;
            if(spray.time<=0){
                endSpray(spray);
                this.bloodSprays.splice(i, 1);
                i--;
            }
        }
    }

    processBodySeparation(clearTicks){
        const snapSeperation = 0.2;
        const maxSnapTicks = 30;
        let i;
        const jointsToAnalyse = [
            'leg_left',
            'leg_right',
            'head',
            'belly',
            'feet_left',
            'feet_right',
            'hand_left',
            'hand_right',
            'thigh_left',
            'thigh_right',
            'shoulder_left',
            'shoulder_right',
        ];

        if(this.invincible) return;

        for (i = 0; i < jointsToAnalyse.length; i++) {
            const part = jointsToAnalyse[i];
            const targetJoint = this.lookupObject[part + '_joint'];
            if(
                !targetJoint ||
                targetJoint.destroyed ||
                !this.lookupObject[part] ||
                simulationTime() < this.releaseImmune
            ) continue;

            vec1.Set(targetJoint.GetAnchorA().x, targetJoint.GetAnchorA().y);
            vec2.Set(targetJoint.GetAnchorB().x, targetJoint.GetAnchorB().y);
            b2SubVec2(vec1, vec2);

            if(vec1.Length() > snapSeperation && !clearTicks){
                if(targetJoint.snapTick === undefined) targetJoint.snapTick = 0;
                targetJoint.snapTick++;

                if(targetJoint.snapTick >= maxSnapTicks){
                    this.collisionUpdates.push({
                        type: Humanoid.GORE_SNAP,
                        target: part,
                    });
                    targetJoint.snapTick = 0;
                }
            }else{
                targetJoint.snapTick = 0;
            }
        }
        if(clearTicks) return;

        for(i = 0; i<this.vains.length; i++){
            const vain = this.vains[i];

            for (let jointEdge = vain.GetJointList(); getPointer(jointEdge) !== getPointer(NULL); jointEdge = jointEdge.get_next()) {

                let targetJoint = jointEdge.joint;
                if (!targetJoint) continue;

                let skip = false;

                if(targetJoint.GetType === Box2D.e_distanceJoint){
                    targetJoint = Box2D.castObject(targetJoint, Box2D.b2DistanceJoint);
                    if(targetJoint.get_minLength() === targetJoint.get_maxLength()){
                        skip = true;
                    }
                }else{
                    targetJoint = game.editor.CastJoint(targetJoint);
                }

                if(!skip){
                    vec1.Set(targetJoint.GetAnchorA().x, targetJoint.GetAnchorA().y);
                    vec2.Set(targetJoint.GetAnchorB().x, targetJoint.GetAnchorB().y);

                    const distance = vec1;
                    b2SubVec2(distance, vec2);

                    if(distance.Length() > snapSeperation){
                        if(targetJoint.snapTick === undefined) targetJoint.snapTick = 0;
                        targetJoint.snapTick++;

                        if(targetJoint.snapTick>= maxSnapTicks){
                            game.editor.deleteObjects([targetJoint]);
                            if(!vain.vainRopeJoint.destroyed){
                                game.editor.deleteObjects([vain.vainRopeJoint]);
                            }
                        }
                    }else{
                        targetJoint.snapTick = 0;
                    }
                }
            }
        }
    }

    static GORE_BASH = 0;
    static GORE_SNAP = 1;

    dealDamage(damage, body){
        if(game.tutorialMode || this.invincible) return;

        this.life -= damage;
        const part = body && !body.destroyed ? body : null;
        const mark = part ?? [this.lookupObject.body, this.lookupObject.head].find(body => body && !body.destroyed);
        recordReplayEvent('damage', {who: this.replayActor(), part: part?.mySprite.data.refName, damage}, mark?.GetPosition());

        this.setExpression(Humanoid.EXPRESSION_PAIN);

        if(damage >= 10000){
            for(let part in Humanoid.BODY_PARTS){
                this.collisionUpdates.push({
                    type: Humanoid.GORE_BASH,
                    target: Humanoid.BODY_PARTS[part]
                });
            }
        }
    }

    initContactListener() {
        super.initContactListener();
        var self = this;
        this.contactListener.PreSolve = function (contact, impulse) {
            const bodyA = contact.GetFixtureA().GetBody();
            const bodyB = contact.GetFixtureB().GetBody();
            if(!bodyA.preSolveVelicity) bodyA.preSolveVelicity = b2CloneVec2(bodyA.GetLinearVelocity());
            else bodyA.preSolveVelicity.Set(bodyA.GetLinearVelocity().x, bodyA.GetLinearVelocity().y)
            bodyA.preSolveVelicityCounter = bodyA.preSolveVelicityCounter !== undefined ? bodyA.preSolveVelicityCounter + 1 : 1;

            if(!bodyB.preSolveVelicity) bodyB.preSolveVelicity = b2CloneVec2(bodyB.GetLinearVelocity());
            else bodyB.preSolveVelicity.Set(bodyB.GetLinearVelocity().x, bodyB.GetLinearVelocity().y)
            bodyB.preSolveVelicityCounter = bodyB.preSolveVelicityCounter !== undefined ? bodyB.preSolveVelicityCounter + 1 : 1;

        }
        this.contactListener.PostSolve = function (contact, impulse) {

            if(!contact.GetFixtureA().GetBody().mySprite || !contact.GetFixtureB().GetBody().mySprite) return;

            let characterBody;
            let otherBody;
            let otherFixture;

            if(game.editor.retrieveSubClassFromBody(contact.GetFixtureA().GetBody()) === self){
                characterBody = contact.GetFixtureA().GetBody();
                otherBody = contact.GetFixtureB().GetBody();
                otherFixture = contact.GetFixtureB();
            }else{
                characterBody = contact.GetFixtureB().GetBody();
                otherBody = contact.GetFixtureA().GetBody();
                otherFixture = contact.GetFixtureA();
            }
            if(otherFixture.GetDensity() <= 0.0011) return;
            if((otherBody.isVehiclePart && characterBody.mainHumanoid) || otherBody.noImpactDamage) return;

            if (!self.isPortalTransitActive() &&
                (otherBody.mySprite.data.prefabID != characterBody.mySprite.data.prefabID ||
                    otherBody.mySprite.data.prefabID == undefined)) {

                const count = contact.GetManifold().get_pointCount();

                let force = 0;
                for (let j = 0; j < count; j++) force = Math.max(force, impulse.get_normalImpulses(j));

                const minForceForDamage = 10.0;
                const forceToDamageDivider = 50.0;

                const bodyA = contact.GetFixtureA().GetBody();
                const bodyB = contact.GetFixtureB().GetBody();
                const velocityA = bodyA.GetLinearVelocity().Length();
                const velocityB = bodyB.GetLinearVelocity().Length();
                let impactAngle = (velocityA > velocityB) ? Math.atan2(bodyA.GetLinearVelocity().get_y(), bodyA.GetLinearVelocity().get_x()) : Math.atan2(bodyB.GetLinearVelocity().get_y(), bodyB.GetLinearVelocity().get_x());
                impactAngle *= game.editor.RAD2DEG + 180;
                const velocitySum = velocityA + velocityB;


                let allowSound = true;
                if(bodyA.recentlyImpactedBodies && bodyA.recentlyImpactedBodies.includes(bodyB)) allowSound = false;
                if(bodyB.recentlyImpactedBodies && bodyB.recentlyImpactedBodies.includes(bodyA)) allowSound = false;

                if(velocitySum > 10 && force> characterBody.GetMass() * Math.max(minForceForDamage, characterBody.impactSpeed ?? 0) && !characterBody.noDamage){
                    self.dealDamage(force/forceToDamageDivider, characterBody);

                    if(!bodyA.recentlyImpactedBodies) bodyA.recentlyImpactedBodies = [];
                    bodyA.recentlyImpactedBodies.push(bodyB);

                    if(allowSound) AudioManager.playSFX(['bodyhit1', 'bodyhit2','bodyhit3'], 0.3, 1.0 + 0.4 * Math.random()-0.2, characterBody.GetPosition());
                }

                let forceDamage = 0;


                if(characterBody.preSolveVelicity && otherBody.preSolveVelicity && simulationTime() > self.releaseImmune ){
                    const charOtherBodyDiff = vec1;
                    charOtherBodyDiff.Set(characterBody.GetPosition().x, characterBody.GetPosition().y);
                    b2SubVec2(charOtherBodyDiff, otherBody.GetPosition());
                    const dotProductChar = b2DotVV(characterBody.preSolveVelicity, charOtherBodyDiff) *-1;

                    const otherBodyCharDiff = vec2;
                    vec2.Set(otherBody.GetPosition().x, otherBody.GetPosition().y);
                    b2SubVec2(otherBodyCharDiff, characterBody.GetPosition());
                    const dotProductOther = b2DotVV(otherBody.preSolveVelicity, otherBodyCharDiff) *-1;

                    if(dotProductChar>0){
                        forceDamage += characterBody.preSolveVelicity.LengthSquared() * characterBody.GetMass();
                    }

                    if(dotProductOther>0){
                        forceDamage += otherBody.preSolveVelicity.LengthSquared() * otherBody.GetMass();
                    }

                    if(otherBody.isBeartrapSpike) forceDamage *= 20;

                    if(characterBody == self.lookupObject["belly"]) forceDamage /= 3;

                    if (forceDamage > Settings.bashForce / 2) requestHitstop(HITSTOP_FRAMES.IMPACT, characterBody.GetPosition(), {victim: self.lookupObject._bodies, attacker: otherBody});

                    if (forceDamage > Settings.bashForce / 4 && Settings.goreEnabled) {
                        if (characterBody == self.lookupObject["head"]) {
                            if (PrefabManager.chancePercent(30)) self.collisionUpdates.push({
                                type: Humanoid.GORE_SNAP,
                                target: "eye_right"
                            });
                            if (PrefabManager.chancePercent(30)) self.collisionUpdates.push({
                                type: Humanoid.GORE_SNAP,
                                target: "eye_left"
                            });
                        }
                    }

                    if (characterBody.mySprite.data.refName != "" && forceDamage > Settings.bashForce) {
                        self.collisionUpdates.push({
                            type: Humanoid.GORE_BASH,
                            target: characterBody.mySprite.data.refName,
                        });
                    }
                }
            }
            characterBody.preSolveVelicityCounter--;
            if(characterBody.preSolveVelicityCounter <= 0){
                delete characterBody.preSolveVelicityCounter;
            }
            otherBody.preSolveVelicityCounter--;
            if(otherBody.preSolveVelicityCounter <= 0){
                delete otherBody.preSolveVelicityCounter;
            }
        }
    }
    static connectedBodyRefs = {}
    static BODY_PARTS = {
        HEAD: 'head',
        BODY: 'body',
        THIGH_LEFT: 'thigh_left',
        THIGH_RIGHT: 'thigh_right',
        LEG_LEFT: 'leg_left',
        LEG_RIGHT: 'leg_right',
        FEET_LEFT: 'feet_left',
        FEET_RIGHT: 'feet_right',
        SHOULDER_LEFT: 'shoulder_left',
        SHOULDER_RIGHT: 'shoulder_right',
        ARM_LEFT: 'arm_left',
        ARM_RIGHT: 'arm_right',
        HAND_LEFT: 'hand_left',
        HAND_RIGHT: 'hand_right',
        BELLY: 'belly',
    }

    // A joint's local anchor is a view into the joint's own memory. The joint
    // is destroyed with the limb right after the spray is created, and Box2D
    // hands that memory to the next joint it allocates, so a spray keeping the
    // view would wander off to wherever that joint's anchor happens to be.
    // Keep the numbers instead.
    addBloodEmitters(target, type){
        const bloodTime = 6500;
        const baseBody = this.lookupObject[target];

        if(type === Humanoid.GORE_SNAP){

            const targetJoint = this.lookupObject[target + "_joint"];
            if(baseBody && targetJoint){

                let targetAngle = 0;
                if([Humanoid.BODY_PARTS.HEAD].includes(target)){
                    targetAngle = -Settings.pihalve;
                }else{
                    targetAngle = Settings.pihalve;
                }

                const targetBody1 = targetJoint.GetBodyA() == baseBody ? targetJoint.GetBodyB() : targetJoint.GetBodyA();
                const targetBody2 = targetJoint.GetBodyA() == baseBody ? targetJoint.GetBodyA() : targetJoint.GetBodyB();
                const targetAnchor1 = copyAnchor(targetJoint.GetBodyA() == baseBody ? targetJoint.GetLocalAnchorB() : targetJoint.GetLocalAnchorA());
                const targetAnchor2 = copyAnchor(targetJoint.GetBodyA() == baseBody ? targetJoint.GetLocalAnchorA() : targetJoint.GetLocalAnchorB());

                this.bloodSprays.push({body:targetBody1, anchor:targetAnchor1, angle:targetAngle, time:bloodTime});
                this.bloodSprays.push({body:targetBody2, anchor:targetAnchor2, angle:-targetAngle, time:bloodTime, strength:0.55});
            }

        }else{
            for (let jointEdge = baseBody.GetJointList(); getPointer(jointEdge) !== getPointer(NULL); jointEdge = jointEdge.get_next()) {
                let joint = jointEdge.joint;
                const body = joint.GetBodyA() === baseBody ? joint.GetBodyB() : joint.GetBodyA();

                if(body.isFlesh && joint.GetType() === Box2D.e_revoluteJoint && !['eye_left', 'eye_right'].includes(body.mySprite.data.refName)){
                    joint = Box2D.castObject(joint, Box2D.b2RevoluteJoint);
                    let angle = Settings.pihalve;
                    if(joint === this.lookupObject[body.mySprite.data.refName+'_joint']){
                        angle = -Settings.pihalve;
                    }
                    if(body.mySprite.data.refName === 'head') angle *= -1;
                    const anchor = copyAnchor(joint.GetBodyA() === baseBody ? joint.GetLocalAnchorB() : joint.GetLocalAnchorA());
                    this.bloodSprays.push({body, anchor, angle, time:bloodTime});
                }
            }
        }



    }
    doCollisionUpdate(update) {
        if(game.tutorialMode) return;
        if ((update.target == 'head' || update.target == 'body') && this.bleedTimer < 0) this.bleedTimer = 0;

        // drop mask
        if(update.target === 'eye_right' || update.target === 'head'){
            const targetBody = this.lookupObject['eye_right'];
            if (targetBody) {
                this.dropMask();
            }
        }

        switch (update.type) {
            case Humanoid.GORE_BASH:

                var targetBody = this.lookupObject[update.target];
                if (targetBody) {
                    recordReplayEvent('bash', {who: this.replayActor(), part: update.target}, targetBody.GetPosition());
                    requestHitstop([Humanoid.BODY_PARTS.HEAD, Humanoid.BODY_PARTS.BODY].includes(update.target) ? HITSTOP_FRAMES.HEAD_BASH : HITSTOP_FRAMES.LIMB_BASH, targetBody.GetPosition(), {victim: this.lookupObject._bodies});
                    this.addBloodEmitters(update.target, update.type);
                    for (var i = 1; i < this.collisionUpdates.length; i++) {
                        if (this.collisionUpdates[i].target === update.target) {
                            this.collisionUpdates.splice(i, 1);
                            i--;
                        }
                    }

                    generateGoreParticles(update.target, targetBody.mySprite, targetBody.GetPosition(), targetBody.GetAngle(), targetBody.GetLinearVelocity(), this.noGoreParticles);
                    emitterManager.playOnceEmitter("gorecloud", targetBody, targetBody.GetPosition());
                    AudioManager.playSFX(['bash1', 'bash2', 'bash3', 'bash4'], 0.3, 1.0+Math.random()*.2-.1, targetBody.GetPosition());

                    for (let connectedJointEdge = targetBody.GetJointList(); getPointer(connectedJointEdge) !== getPointer(NULL); connectedJointEdge = connectedJointEdge.get_next()) {
                        const joint = connectedJointEdge.joint;
                        if(joint.GetBodyA() != targetBody && joint.GetBodyA().isFlesh) game.editor.queueDecalToBody(joint.GetBodyA(), joint.GetAnchorA(), "Decal.png", true, 1, 0, {longSpray: true});
                        if(joint.GetBodyB() != targetBody && joint.GetBodyB().isFlesh) game.editor.queueDecalToBody(joint.GetBodyB(), joint.GetAnchorA(), "Decal.png", true, 1, 0, {longSpray: true});
                    }

                    // Fix bash damaage & also set snapped for objects that got detached from the player
                    if(this.lookupObject[Humanoid.BODY_PARTS.SHOULDER_LEFT] === targetBody){
                        if(this.lookupObject[Humanoid.BODY_PARTS.ARM_LEFT]) this.lookupObject[Humanoid.BODY_PARTS.ARM_LEFT].snapped = true;
                        if(this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT]) this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT].snapped = true;
                    } else if(this.lookupObject[Humanoid.BODY_PARTS.SHOULDER_RIGHT] === targetBody){
                        if(this.lookupObject[Humanoid.BODY_PARTS.ARM_RIGHT]) this.lookupObject[Humanoid.BODY_PARTS.ARM_RIGHT].snapped = true;
                        if(this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT]) this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT].snapped = true;
                    } else if(this.lookupObject[Humanoid.BODY_PARTS.THIGH_LEFT] === targetBody){
                        if(this.lookupObject[Humanoid.BODY_PARTS.LEG_LEFT]) this.lookupObject[Humanoid.BODY_PARTS.LEG_LEFT].snapped = true;
                        if(this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT]) this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT].snapped = true;
                    } else if(this.lookupObject[Humanoid.BODY_PARTS.THIGH_RIGHT] === targetBody){
                        if(this.lookupObject[Humanoid.BODY_PARTS.LEG_RIGHT]) this.lookupObject[Humanoid.BODY_PARTS.LEG_RIGHT].snapped = true;
                        if(this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT]) this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT].snapped = true;
                    } else if(this.lookupObject[Humanoid.BODY_PARTS.ARM_LEFT] === targetBody){
                        if(this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT]) this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT].snapped = true;
                    } else if(this.lookupObject[Humanoid.BODY_PARTS.ARM_RIGHT] === targetBody){
                        if(this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT]) this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT].snapped = true;
                    } else if(this.lookupObject[Humanoid.BODY_PARTS.LEG_LEFT] === targetBody){
                        if(this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT]) this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT].snapped = true;
                    } else if(this.lookupObject[Humanoid.BODY_PARTS.LEG_RIGHT] === targetBody){
                        if(this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT]) this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT].snapped = true;
                    } else if(this.lookupObject[Humanoid.BODY_PARTS.HEAD] === targetBody){
                        if(this.lookupObject['eye_left']) this.lookupObject['eye_left'].snapped = true;
                        if(this.lookupObject['eye_right']) this.lookupObject['eye_right'].snapped = true;
                    }

                    this.dealDamage(30, targetBody);
                    if([this.lookupObject[Humanoid.BODY_PARTS.HEAD], this.lookupObject[Humanoid.BODY_PARTS.BODY]].includes(targetBody)){
                        if(this.hat) this.hat.detach();
                        this.dealDamage(1000, targetBody);
                    }

                    if(targetBody.grabJoints){
                        targetBody.grabJoints.forEach(grabJoint=>{
                            game.editor.DestroyJoint(grabJoint);
                            delete targetBody.grabJoints;
                        })
                    }
                    game.editor.deleteObjects([targetBody]);

                }

                break;
            case Humanoid.GORE_SNAP:
                const targetJoint = this.lookupObject[update.target + "_joint"];
                if (targetJoint && !targetJoint.destroyed && this.lookupObject[update.target]) {

                    this.addBloodEmitters(update.target, update.type);

                    if (targetJoint.GetBodyA().connectedSpike || targetJoint.GetBodyB().connectedSpike) break;


                    const anchorAPos = targetJoint.GetAnchorA();
                    const anchorBPos = targetJoint.GetAnchorB();
                    recordReplayEvent('snap', {who: this.replayActor(), part: update.target}, anchorAPos);
                    requestHitstop(
                        ['eye_left', 'eye_right'].includes(update.target) ? HITSTOP_FRAMES.EYE
                            : [Humanoid.BODY_PARTS.HEAD, Humanoid.BODY_PARTS.BELLY].includes(update.target) ? HITSTOP_FRAMES.HEAD
                            : HITSTOP_FRAMES.LIMB,
                        anchorAPos,
                        {victim: this.lookupObject._bodies}
                    );


                    let vainBodies;
                    let joint;

                    if(update.target === Humanoid.BODY_PARTS.BELLY && !this.noGoreParticles){
                        const torso = this.lookupObject[Humanoid.BODY_PARTS.BODY];
                        const torsoIsA = targetJoint.GetBodyA() === torso;
                        const forwardAngle = torso.GetAngle() + (this.flipped ? Math.PI : 0);
                        ({guts: vainBodies, rope: joint} = spillIntestines(
                            torso,
                            this.lookupObject[Humanoid.BODY_PARTS.BELLY],
                            torsoIsA ? anchorAPos : anchorBPos,
                            torsoIsA ? anchorBPos : anchorAPos,
                            forwardAngle
                        ));
                    }else{
                        let vainPrefab = '{"objects":[[4,' + anchorAPos.x * Settings.PTM + ',' + anchorAPos.y * Settings.PTM + ',0,{},"Vain"]]}'

                        vainBodies = game.editor.buildJSON(JSON.parse(vainPrefab));

                        let vainSize = (vainBodies._bodies[0].originalGraphic.height * vainBodies._bodies.length) / Settings.PTM;

                        vainBodies._bodies[0].SetTransform(anchorAPos, vainBodies._bodies[0].GetAngle());

                        let revoluteJointDef = new Box2D.b2RevoluteJointDef();
                        revoluteJointDef.Initialize(targetJoint.GetBodyA(), vainBodies._bodies[0], anchorAPos);

                        revoluteJointDef.set_collideConnected(false);

                        joint = game.editor.CreateJoint(revoluteJointDef);
                        Box2D.destroy(revoluteJointDef);

                        revoluteJointDef = new Box2D.b2RevoluteJointDef();
                        vainBodies._bodies[3].SetTransform(anchorBPos, vainBodies._bodies[3].GetAngle());
                        revoluteJointDef.Initialize(targetJoint.GetBodyB(), vainBodies._bodies[3], anchorBPos);


                        revoluteJointDef.set_collideConnected(false);
                        joint = game.editor.CreateJoint(revoluteJointDef);
                        Box2D.destroy(revoluteJointDef);

                        let ropeJointDef;

                        ropeJointDef = new Box2D.b2DistanceJointDef();
                        ropeJointDef.Initialize(targetJoint.GetBodyA(), targetJoint.GetBodyB(), anchorAPos, anchorAPos);

                        const length = ropeJointDef.get_length();
                        ropeJointDef.set_minLength(0);
                        ropeJointDef.set_maxLength(1.0);
                        ropeJointDef.set_stiffness(0);
                        ropeJointDef.set_damping(0);

                        joint = game.editor.CreateJoint(ropeJointDef);

                        Box2D.destroy(ropeJointDef);
                    }

                    [targetJoint.GetBodyA(), targetJoint.GetBodyB()].forEach(body => {
                        if(this.lookupObject[Humanoid.BODY_PARTS.SHOULDER_LEFT] === body){
                            if(this.lookupObject[Humanoid.BODY_PARTS.ARM_LEFT])this.lookupObject[Humanoid.BODY_PARTS.ARM_LEFT].snapped = true;
                            if(this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT])this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT].snapped = true;
                        } else if(this.lookupObject[Humanoid.BODY_PARTS.SHOULDER_RIGHT] === body){
                            if(this.lookupObject[Humanoid.BODY_PARTS.ARM_RIGHT])this.lookupObject[Humanoid.BODY_PARTS.ARM_RIGHT].snapped = true;
                            if(this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT])this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT].snapped = true;
                        } else if(this.lookupObject[Humanoid.BODY_PARTS.THIGH_LEFT] === body){
                            if(this.lookupObject[Humanoid.BODY_PARTS.LEG_LEFT])this.lookupObject[Humanoid.BODY_PARTS.LEG_LEFT].snapped = true;
                            if(this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT])this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT].snapped = true;
                        } else if(this.lookupObject[Humanoid.BODY_PARTS.THIGH_RIGHT] === body){
                            if(this.lookupObject[Humanoid.BODY_PARTS.LEG_RIGHT])this.lookupObject[Humanoid.BODY_PARTS.LEG_RIGHT].snapped = true;
                            if(this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT])this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT].snapped = true;
                        }
                    });
                    if(update.target === Humanoid.BODY_PARTS.BELLY){
                        [
                            Humanoid.BODY_PARTS.THIGH_LEFT,
                            Humanoid.BODY_PARTS.THIGH_RIGHT,
                            Humanoid.BODY_PARTS.LEG_LEFT,
                            Humanoid.BODY_PARTS.LEG_RIGHT,
                            Humanoid.BODY_PARTS.FEET_LEFT,
                            Humanoid.BODY_PARTS.FEET_RIGHT,
                        ].forEach(part => {
                            if(this.lookupObject[part]) this.lookupObject[part].snapped = true;
                        });
                    }
                    //carve bodies

                    const targetBody = this.lookupObject[update.target];
                    targetBody.snapped = true;

                    if(["eye_left", "eye_right"].includes(update.target)){
                        game.editor.setBodyCollision(targetBody, [1]);
                    }

                    if (targetJoint.GetBodyA().isFlesh){
                        game.editor.queueDecalToBody(targetJoint.GetBodyA(), anchorAPos, "Decal.png", true, 1, 0, {longSpray: true});
                    }
                    if (targetJoint.GetBodyB().isFlesh){
                        game.editor.queueDecalToBody(targetJoint.GetBodyB(), anchorBPos, "Decal.png", true, 1, 0, {longSpray: true});
                    }

                    game.editor.deleteObjects([targetJoint]);

                    AudioManager.playSFX(['snap1', 'snap2', 'snap3', 'snap4'], 0.3, 1.0+Math.random()*.2-.1, targetJoint.GetBodyA().GetPosition());

                    this.vains.push(...vainBodies._bodies);

                    //fix display positions:
                    const swapBodies = vainBodies._bodies.concat().reverse();
                    let tarSprite;
                    const tarIndex = this.lookupObject[update.target].myTexture.parent.getChildIndex(this.lookupObject[update.target].myTexture);
                    for (var i = 0; i < swapBodies.length; i++) {
                        tarSprite = swapBodies[i].myTexture || swapBodies[i].mySprite;
                        swapBodies[i].isVain = true;
                        swapBodies[i].vainRopeJoint = joint;
                        tarSprite.parent.removeChild(tarSprite);
                        this.lookupObject[update.target].myTexture.parent.addChildAt(tarSprite, tarIndex);
                    }
                }
                break;
        }

    }

    addJoint(joint, bodyB){
    }

    positionBody(direction) {
        const positions = {
            up: {
                thigh_right: {
                    angle: 10,
                    reference: "body",
                    clockwise: 1
                },
                thigh_left: {
                    angle: 10,
                    reference: "body",
                    clockwise: 1
                },
                leg_right: {
                    angle: 10,
                    reference: "thigh_right",
                    clockwise: 1
                },
                leg_left: {
                    angle: 10,
                    reference: "thigh_left",
                    clockwise: 1
                },
                shoulder_right: {
                    angle: 170,
                    reference: "body",
                    clockwise: -1
                },
                shoulder_left: {
                    angle: 170,
                    reference: "body",
                    clockwise: -1
                },
                arm_right: {
                    angle: 10,
                    reference: "shoulder_right",
                    clockwise: -1
                },
                arm_left: {
                    angle: 10,
                    reference: "shoulder_left",
                    clockwise: -1
                },
                head: {
                    angle: 40,
                    reference: "body",
                    clockwise: 0
                },
                belly: {
                    angle: 0,
                    reference: "body",
                    clockwise: 0,
                }
            },
            down: {
                thigh_right: {
                    angle: 120,
                    reference: "body",
                    clockwise: -1
                },
                thigh_left: {
                    angle: 120,
                    reference: "body",
                    clockwise: -1
                },
                leg_right: {
                    angle: -140,
                    reference: "thigh_right",
                    clockwise: 1
                },
                leg_left: {
                    angle: -140,
                    reference: "thigh_left",
                    clockwise: 1
                },
                shoulder_right: {
                    angle: 0,
                    reference: "body",
                    clockwise: 1
                },
                shoulder_left: {
                    angle: 0,
                    reference: "body",
                    clockwise: 1
                },
                arm_right: {
                    angle: 60,
                    reference: "shoulder_right",
                    clockwise: -1
                },
                arm_left: {
                    angle: 60,
                    reference: "shoulder_left",
                    clockwise: -1
                },
                head: {
                    angle: -64,
                    reference: "body",
                    clockwise: 0
                },
                belly: {
                    angle: 0,
                    reference: "body",
                    clockwise: 0,
                }
            },
            right: {
                thigh_right: {
                    angle: 10,
                    reference: "body",
                    clockwise: 1
                },
                thigh_left: {
                    angle: 10,
                    reference: "body",
                    clockwise: 1
                },
                leg_right: {
                    angle: 10,
                    reference: "thigh_right",
                    clockwise: 1
                },
                leg_left: {
                    angle: 10,
                    reference: "thigh_left",
                    clockwise: 1
                },
                shoulder_right: {
                    angle: 90,
                    reference: "body",
                    clockwise: -1
                },
                shoulder_left: {
                    angle: 90,
                    reference: "body",
                    clockwise: -1
                },
                arm_right: {
                    angle: 0,
                    reference: "shoulder_right",
                    clockwise: -1
                },
                arm_left: {
                    angle: 0,
                    reference: "shoulder_left",
                    clockwise: -1
                },
                head: {
                    angle: 40,
                    reference: "body",
                    clockwise: 0
                },
                belly: {
                    angle: 0,
                    reference: "body",
                    clockwise: 0,
                }
            },
            left: {
                thigh_right: {
                    angle: 10,
                    reference: "body",
                    clockwise: 1
                },
                thigh_left: {
                    angle: 10,
                    reference: "body",
                    clockwise: 1
                },
                leg_right: {
                    angle: -90,
                    reference: "thigh_right",
                    clockwise: 1
                },
                leg_left: {
                    angle: -90,
                    reference: "thigh_left",
                    clockwise: 1
                },
                shoulder_right: {
                    angle: 190,
                    reference: "body",
                    clockwise: -1
                },
                shoulder_left: {
                    angle: 190,
                    reference: "body",
                    clockwise: -1
                },
                arm_right: {
                    angle: 90,
                    reference: "shoulder_right",
                    clockwise: -1
                },
                arm_left: {
                    angle: 90,
                    reference: "shoulder_left",
                    clockwise: -1
                },
                head: {
                    angle: 40,
                    reference: "body",
                    clockwise: 0
                },
                belly: {
                    angle: 0,
                    reference: "body",
                    clockwise: 0,
                }
            },
        }

        const bodyGroupMap = {
            [Humanoid.BODY_PARTS.FEET_LEFT]:'leftLeg',
            [Humanoid.BODY_PARTS.LEG_LEFT]:'leftLeg',
            [Humanoid.BODY_PARTS.THIGH_LEFT]:'leftLeg',
            [Humanoid.BODY_PARTS.FEET_RIGHT]:'rightLeg',
            [Humanoid.BODY_PARTS.LEG_RIGHT]:'rightLeg',
            [Humanoid.BODY_PARTS.THIGH_RIGHT]:'rightLeg',
            [Humanoid.BODY_PARTS.BELLY]:'leftLeg',
            [Humanoid.BODY_PARTS.BELLY]:'rightLeg',
        }

        const ignoreBodyGroup = {};
        Object.keys(bodyGroupMap).forEach(key => {
            const refJoint = this.lookupObject[key + '_joint'];
            if(refJoint && refJoint.snapTick && refJoint.snapTick>12){
                const groupKey = bodyGroupMap[key];

                ignoreBodyGroup[groupKey] = true;
            }
        })
        if(!this.lookupObject[Humanoid.BODY_PARTS.BELLY + '_joint']){
            ignoreBodyGroup.leftLeg = true;
            ignoreBodyGroup.rightLeg = true;
        }



        let targetPosition = positions[direction];
        // if (direction == 'random') targetPosition = positions[this.randomPose];

        for (let body_part in targetPosition) {
            if (targetPosition.hasOwnProperty(body_part)) {

                let body = this.lookupObject[body_part];
                if (!body) continue;
                let refBody = this.lookupObject[targetPosition[body_part].reference];
                if (!refBody) continue;
                let refJoint = this.lookupObject[body_part + '_joint'];
                if (!refJoint) continue;

                const groupKey = bodyGroupMap[body_part];
                if(ignoreBodyGroup[groupKey]) continue;

                if(refJoint.snapTick && refJoint.snapTick > 10){
                    // make sure the character does not break his own body
                    const leftLeg = [Humanoid.BODY_PARTS.FEET_LEFT, Humanoid.BODY_PARTS.LEG_LEFT, Humanoid.BODY_PARTS.THIGH_LEFT];
                    const rightLeg = [Humanoid.BODY_PARTS.FEET_RIGHT, Humanoid.BODY_PARTS.LEG_RIGHT, Humanoid.BODY_PARTS.THIGH_RIGHT];


                    [leftLeg, rightLeg].forEach(groupedBodies => {
                        if(groupedBodies.includes(body_part)){
                            groupedBodies.forEach(body_part => {
                                let otherRefJoint = this.lookupObject[body_part + '_joint'];
                                if(otherRefJoint){
                                    otherRefJoint.snapTick = refJoint.snapTick;
                                }
                            })
                        }
                    })
                    continue;
                }

                if (targetPosition[body_part].reference != 'body' && !this.lookupObject[targetPosition[body_part].reference + '_joint']) continue;

                let limbAngle = this.flipped ? targetPosition[body_part].angle : - targetPosition[body_part].angle;
                let desiredAngle = refBody.GetAngle() + limbAngle * game.editor.DEG2RAD;
                let nextAngle = body.GetAngle() + body.GetAngularVelocity() / 15;
                let totalRotation = desiredAngle - nextAngle;

                if (targetPosition[body_part].clockwise == 0 || !refJoint || !refJoint.IsLimitEnabled()) {
                    while (totalRotation < -180 * game.editor.DEG2RAD) totalRotation += 360 * game.editor.DEG2RAD;
                    while (totalRotation > 180 * game.editor.DEG2RAD) totalRotation -= 360 * game.editor.DEG2RAD;
                } else if (targetPosition[body_part].clockwise == 1) {
                    if (totalRotation < 0) {

                        var upperLimit = refJoint.GetUpperLimit();
                        var lowerLimit = refJoint.GetLowerLimit();

                        let upperRotDif = body.GetAngle() - upperLimit;
                        let lowerRotDif = body.GetAngle() - lowerLimit;

                        while (upperRotDif < -180 * game.editor.DEG2RAD) upperRotDif += 360 * game.editor.DEG2RAD;
                        while (upperRotDif > 180 * game.editor.DEG2RAD) upperRotDif -= 360 * game.editor.DEG2RAD;

                        while (lowerRotDif < -180 * game.editor.DEG2RAD) lowerRotDif += 360 * game.editor.DEG2RAD;
                        while (lowerRotDif > 180 * game.editor.DEG2RAD) lowerRotDif -= 360 * game.editor.DEG2RAD;

                        if (lowerLimit > upperLimit) {
                            while (totalRotation < 0 * game.editor.DEG2RAD) totalRotation += 360 * game.editor.DEG2RAD;
                        }
                    }
                } else if (targetPosition[body_part].clockwise == -1) {
                    if (totalRotation > 0) {

                        var upperLimit = refJoint.GetUpperLimit();
                        var lowerLimit = refJoint.GetLowerLimit();

                        let upperRotDif = body.GetAngle() - upperLimit;
                        let lowerRotDif = body.GetAngle() - lowerLimit;

                        while (upperRotDif < -180 * game.editor.DEG2RAD) upperRotDif += 360 * game.editor.DEG2RAD;
                        while (upperRotDif > 180 * game.editor.DEG2RAD) upperRotDif -= 360 * game.editor.DEG2RAD;

                        while (lowerRotDif < -180 * game.editor.DEG2RAD) lowerRotDif += 360 * game.editor.DEG2RAD;
                        while (lowerRotDif > 180 * game.editor.DEG2RAD) lowerRotDif -= 360 * game.editor.DEG2RAD;

                        if (lowerLimit > upperLimit) {
                            while (totalRotation > 0 * game.editor.DEG2RAD) totalRotation -= 360 * game.editor.DEG2RAD;
                        }
                    }
                }
                const torqueLimiter = .15;
                let desiredAngularVelocity = totalRotation * 60;
                let torque = body.GetInertia() * desiredAngularVelocity / (1/30.0);
                if(Math.abs(torque) > 1) body.ApplyTorque(torque * torqueLimiter);
            }
        }
    }

    patchJointAngles(){
        this.patchJointAngle([Humanoid.BODY_PARTS.HEAD, 'eye_left', 'eye_right']);
        this.patchJointAngle(['eye_left']);
        this.patchJointAngle(['eye_right']);

        this.patchJointAngle([Humanoid.BODY_PARTS.SHOULDER_LEFT, Humanoid.BODY_PARTS.ARM_LEFT, Humanoid.BODY_PARTS.HAND_LEFT]);
        this.patchJointAngle([Humanoid.BODY_PARTS.ARM_LEFT, Humanoid.BODY_PARTS.HAND_LEFT]);
        this.patchJointAngle([Humanoid.BODY_PARTS.HAND_LEFT]);

        this.patchJointAngle([Humanoid.BODY_PARTS.SHOULDER_RIGHT, Humanoid.BODY_PARTS.ARM_RIGHT, Humanoid.BODY_PARTS.HAND_RIGHT]);
        this.patchJointAngle([Humanoid.BODY_PARTS.ARM_RIGHT, Humanoid.BODY_PARTS.HAND_RIGHT]);
        this.patchJointAngle([Humanoid.BODY_PARTS.HAND_RIGHT]);

        this.patchJointAngle([Humanoid.BODY_PARTS.THIGH_LEFT, Humanoid.BODY_PARTS.LEG_LEFT, Humanoid.BODY_PARTS.FEET_LEFT]);
        this.patchJointAngle([Humanoid.BODY_PARTS.LEG_LEFT, Humanoid.BODY_PARTS.FEET_LEFT]);
        this.patchJointAngle([Humanoid.BODY_PARTS.FEET_LEFT]);

        this.patchJointAngle([Humanoid.BODY_PARTS.THIGH_RIGHT, Humanoid.BODY_PARTS.LEG_RIGHT, Humanoid.BODY_PARTS.FEET_RIGHT]);
        this.patchJointAngle([Humanoid.BODY_PARTS.LEG_RIGHT, Humanoid.BODY_PARTS.FEET_RIGHT]);
        this.patchJointAngle([Humanoid.BODY_PARTS.FEET_RIGHT]);
    }

    patchJointAngle(refNames){
        const joint = this.lookupObject[refNames[0]+'_joint'];

        const jointAngle = joint.GetJointAngle();

        const clampedAngle = clampAngleToRange(jointAngle,joint.GetLowerLimit(), joint.GetUpperLimit());
        const angleCorrection = clampedAngle-jointAngle;
        const rotationPoint = joint.GetAnchorA();

        refNames.forEach(linkedBodyRef=> {
            const linkedBody =  this.lookupObject[linkedBodyRef];
            const dx = linkedBody.GetPosition().x-rotationPoint.x;
            const dy = linkedBody.GetPosition().y-rotationPoint.y;
            const da = Math.atan2(dy, dx);
            const dl = Math.sqrt(dx*dx + dy*dy);
            const newRot = da-angleCorrection;
            const newX = rotationPoint.x + dl * Math.cos(newRot);
            const newY = rotationPoint.y + dl * Math.sin(newRot);

            const newPos = vec1;
            newPos.set_x(newX);
            newPos.set_y(newY);

            linkedBody.SetTransform(newPos, linkedBody.GetAngle()-angleCorrection);
        });
    };

    stabalizeJoints(){
        // stabalize shoulders
        this.stabalizeJoint(Humanoid.BODY_PARTS.HAND_LEFT, Humanoid.BODY_PARTS.BODY, Humanoid.BODY_PARTS.SHOULDER_LEFT, [Humanoid.BODY_PARTS.HAND_LEFT, Humanoid.BODY_PARTS.ARM_LEFT]);
        this.stabalizeJoint(Humanoid.BODY_PARTS.ARM_LEFT, Humanoid.BODY_PARTS.BODY, Humanoid.BODY_PARTS.SHOULDER_LEFT, [Humanoid.BODY_PARTS.ARM_LEFT]);

        this.stabalizeJoint(Humanoid.BODY_PARTS.HAND_RIGHT, Humanoid.BODY_PARTS.BODY, Humanoid.BODY_PARTS.SHOULDER_RIGHT, [Humanoid.BODY_PARTS.HAND_RIGHT, Humanoid.BODY_PARTS.ARM_RIGHT]); // add stabalize joints to bodies delete on snap 
        this.stabalizeJoint(Humanoid.BODY_PARTS.ARM_RIGHT, Humanoid.BODY_PARTS.BODY, Humanoid.BODY_PARTS.SHOULDER_RIGHT, [Humanoid.BODY_PARTS.HAND_RIGHT, Humanoid.BODY_PARTS.ARM_RIGHT]);

        this.stabalizeJoint(Humanoid.BODY_PARTS.FEET_LEFT, Humanoid.BODY_PARTS.BODY, Humanoid.BODY_PARTS.THIGH_LEFT, [Humanoid.BODY_PARTS.BELLY, Humanoid.BODY_PARTS.FEET_LEFT, Humanoid.BODY_PARTS.LEG_LEFT]);
        this.stabalizeJoint(Humanoid.BODY_PARTS.LEG_LEFT, Humanoid.BODY_PARTS.BODY, Humanoid.BODY_PARTS.THIGH_LEFT, [Humanoid.BODY_PARTS.BELLY, Humanoid.BODY_PARTS.LEG_LEFT]);

        this.stabalizeJoint(Humanoid.BODY_PARTS.FEET_RIGHT, Humanoid.BODY_PARTS.BODY, Humanoid.BODY_PARTS.THIGH_RIGHT,[Humanoid.BODY_PARTS.BELLY, Humanoid.BODY_PARTS.FEET_RIGHT, Humanoid.BODY_PARTS.LEG_RIGHT]);
        this.stabalizeJoint(Humanoid.BODY_PARTS.LEG_RIGHT, Humanoid.BODY_PARTS.BODY, Humanoid.BODY_PARTS.THIGH_RIGHT, [Humanoid.BODY_PARTS.BELLY, Humanoid.BODY_PARTS.LEG_RIGHT]);
    }
    stabalizeJoint(target, base, baseRefJoint, linkedBodies){
        const targetBody = this.lookupObject[target];
        base = this.lookupObject[base];
        const refJoint = this.lookupObject[`${baseRefJoint}_joint`]

        let anchor = null;
        if(refJoint.GetBodyA() === base){
            anchor = refJoint.GetAnchorA();
        }else{
            anchor = refJoint.GetAnchorB();
        }

        const ropeJointDef = new Box2D.b2DistanceJointDef();

        const targetAnchor = this.lookupObject[`${target}_joint`].GetAnchorA();

        ropeJointDef.Initialize(targetBody, base, targetAnchor, anchor);

        const length = ropeJointDef.get_length();
        ropeJointDef.set_minLength(length);
        ropeJointDef.set_maxLength(length);

        ropeJointDef.set_stiffness(0);
        ropeJointDef.set_damping(0);

        const newJoint = Box2D.castObject(game.editor.CreateJoint(ropeJointDef), Box2D.b2DistanceJoint);
        Box2D.destroy(ropeJointDef);

        let maxLength = 0;
        linkedBodies.forEach((linkedBody, index)=>{

            let nextLinkedBody = index+1 === linkedBodies.length ? baseRefJoint : linkedBodies[index+1];
            const j1 = vec1;
            j1.Set(this.lookupObject[linkedBody+'_joint'].GetAnchorA().x, this.lookupObject[linkedBody+'_joint'].GetAnchorA().y);
            const j2 = vec2;
            j2.Set(this.lookupObject[nextLinkedBody+'_joint'].GetAnchorA().x, this.lookupObject[nextLinkedBody+'_joint'].GetAnchorA().y);

            const inc = j1;
            b2SubVec2(inc, j2);

            maxLength += inc.Length();
        });
        newJoint.SetMaxLength(maxLength);
        newJoint.SetMinLength(0);

        [...linkedBodies, baseRefJoint].forEach(linkedBodyKey => {
            const linkedJoint = this.lookupObject[`${linkedBodyKey}_joint`]
            if(!linkedJoint.linkedJoints) linkedJoint.linkedJoints = [];
            linkedJoint.linkedJoints.push(newJoint);
        });
    }

    checkLimbs(){
        // only intereresting for character
    }

    positionLimb(limb, x, y){
        let baseJoint,
        upperPart,
        lowerJoint,
        lowerPart,
        endJoint,
        endPart,
        invertAngle;

        switch(limb){
            case Humanoid.BODY_PARTS.ARM_LEFT:
                baseJoint = this.lookupObject[Humanoid.BODY_PARTS.SHOULDER_LEFT+"_joint"];
                upperPart = this.lookupObject[Humanoid.BODY_PARTS.SHOULDER_LEFT];
                lowerJoint = this.lookupObject[Humanoid.BODY_PARTS.ARM_LEFT+"_joint"];
                lowerPart = this.lookupObject[Humanoid.BODY_PARTS.ARM_LEFT];
                endJoint = this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT+"_joint"];
                endPart = this.lookupObject[Humanoid.BODY_PARTS.HAND_LEFT];
                invertAngle = this.flipped;
            break;
            case Humanoid.BODY_PARTS.ARM_RIGHT:
                baseJoint = this.lookupObject[Humanoid.BODY_PARTS.SHOULDER_RIGHT+"_joint"];
                upperPart = this.lookupObject[Humanoid.BODY_PARTS.SHOULDER_RIGHT];
                lowerJoint = this.lookupObject[Humanoid.BODY_PARTS.ARM_RIGHT+"_joint"];
                lowerPart = this.lookupObject[Humanoid.BODY_PARTS.ARM_RIGHT];
                endJoint = this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT+"_joint"];
                endPart = this.lookupObject[Humanoid.BODY_PARTS.HAND_RIGHT];
                invertAngle = this.flipped;
            break;
            case Humanoid.BODY_PARTS.LEG_LEFT:
                baseJoint = this.lookupObject[Humanoid.BODY_PARTS.THIGH_LEFT+"_joint"];
                upperPart = this.lookupObject[Humanoid.BODY_PARTS.THIGH_LEFT];
                lowerJoint = this.lookupObject[Humanoid.BODY_PARTS.LEG_LEFT+"_joint"];
                lowerPart = this.lookupObject[Humanoid.BODY_PARTS.LEG_LEFT];
                endJoint = this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT+"_joint"];
                endPart = this.lookupObject[Humanoid.BODY_PARTS.FEET_LEFT];
                invertAngle = !this.flipped;
            break;
            case Humanoid.BODY_PARTS.LEG_RIGHT:
                baseJoint = this.lookupObject[Humanoid.BODY_PARTS.THIGH_RIGHT+"_joint"];
                upperPart = this.lookupObject[Humanoid.BODY_PARTS.THIGH_RIGHT];
                lowerJoint = this.lookupObject[Humanoid.BODY_PARTS.LEG_RIGHT+"_joint"];
                lowerPart = this.lookupObject[Humanoid.BODY_PARTS.LEG_RIGHT];
                endJoint = this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT+"_joint"];
                endPart = this.lookupObject[Humanoid.BODY_PARTS.FEET_RIGHT];
                invertAngle = !this.flipped;
            break;
            case Humanoid.BODY_PARTS.HEAD:
                baseJoint = this.lookupObject[Humanoid.BODY_PARTS.HEAD+"_joint"];
                upperPart = this.lookupObject[Humanoid.BODY_PARTS.HEAD];
                lowerJoint = null;
                lowerPart = null;
                endJoint = null;
                endPart = null;
            break;
        }

        const baseJointPos = new Box2D.b2Vec2(baseJoint.position.x/Settings.PTM, baseJoint.position.y/Settings.PTM);
        let dx = x-baseJointPos.x;
        let dy = y-baseJointPos.y;
        let dl = Math.sqrt(dx*dx+dy*dy);

       const angle = Math.atan2(dy, dx);

        if(!lowerJoint){
            const distanceClone = b2CloneVec2(baseJointPos);
            let anchorDistanceUpper = b2SubVec2(distanceClone,upperPart.GetPosition()).Length();

            const eyeObjects = ['eye_left', 'eye_left_joint', 'eye_right', 'eye_right_joint'];

            if(upperPart === this.lookupObject[Humanoid.BODY_PARTS.HEAD]){
                eyeObjects.forEach(key => {
                    const eyeObject = this.lookupObject[key];

                    if(eyeObject.GetPosition){
                        eyeObject.localVec = b2CloneVec2(upperPart.GetLocalPoint(eyeObject.GetPosition()));
                    }else{
                        const eyePos = vec1;
                        eyePos.Set(eyeObject.position.x/Settings.PTM, eyeObject.position.y/Settings.PTM);
                        eyeObject.localVec = b2CloneVec2(upperPart.GetLocalPoint(eyePos));
                    }
                });
            }

            const newPos = vec1;
            newPos.Set(baseJointPos.x+anchorDistanceUpper*Math.cos(angle), baseJointPos.y+anchorDistanceUpper*Math.sin(angle));
            upperPart.SetTransform(newPos, angle+Settings.pihalve);

            if(upperPart === this.lookupObject[Humanoid.BODY_PARTS.HEAD]){
                eyeObjects.forEach(key => {
                    const eyeObject = this.lookupObject[key];
                    const globalPos = upperPart.GetWorldPoint(eyeObject.localVec);

                    Box2D.destroy(eyeObject.localVec);
                    delete eyeObject.localVec;

                    if(eyeObject.SetTransform){
                        eyeObject.SetTransform(globalPos, angle+Settings.pihalve);
                    } else{
                        eyeObject.position.x = globalPos.x * Settings.PTM;
                        eyeObject.position.y = globalPos.y * Settings.PTM;
                    }
                });
            }

        }else{
            // IK position
            const lowerJointPos = new Box2D.b2Vec2(lowerJoint.position.x/Settings.PTM, lowerJoint.position.y/Settings.PTM);
            const endJointPos = new Box2D.b2Vec2(endJoint.position.x/Settings.PTM, endJoint.position.y/Settings.PTM);

            let posClone = b2CloneVec2(lowerJointPos);
            const upperLength = b2SubVec2(posClone, baseJointPos).Length();

            posClone.Set(endJointPos.x, endJointPos.y);
            const lowerLength = b2SubVec2(posClone, lowerJointPos).Length();

            const totalLength = upperLength+lowerLength;
            const upperLengthShare = upperLength/totalLength;
            const lowerLengthShare = lowerLength/totalLength;

            const baseDiff = Math.min(dl, totalLength);

            const upperAngleChange = Math.acos(Math.max(-1.0, Math.min(1.0, (baseDiff * upperLengthShare) / upperLength)));

            let upperAngle = invertAngle ? angle-upperAngleChange  : angle+upperAngleChange;

            posClone.Set(baseJointPos.x, baseJointPos.y);
            const anchorDistanceUpper = b2SubVec2(posClone, upperPart.GetPosition()).Length();

            posClone.Set(baseJointPos.x+anchorDistanceUpper*Math.cos(upperAngle), baseJointPos.y+anchorDistanceUpper*Math.sin(upperAngle));
            upperPart.SetTransform(posClone, upperAngle-Settings.pihalve);

            posClone.Set(lowerJointPos.x, lowerJointPos.y);
            const anchorDistanceLower = b2SubVec2(posClone, lowerPart.GetPosition()).Length();

            const lowerJointPosRotated = rotateVectorAroundPoint(lowerJointPos, baseJointPos, upperAngle*game.editor.RAD2DEG);
            lowerJointPos.x = lowerJointPosRotated.x;
            lowerJointPos.y = lowerJointPosRotated.y;
            lowerJoint.position.x = lowerJointPos.x*Settings.PTM;
            lowerJoint.position.y = lowerJointPos.y*Settings.PTM;
            Box2D.destroy(lowerJointPosRotated);


            const lowerAngleChange = Math.acos(Math.max(-1.0, Math.min(1.0, (baseDiff * lowerLengthShare) / lowerLength)));
            const lowerAngle = invertAngle ? angle+lowerAngleChange : angle-lowerAngleChange;

            posClone.Set(lowerJointPos.x+anchorDistanceLower*Math.cos(lowerAngle), lowerJointPos.y+anchorDistanceLower*Math.sin(lowerAngle))
            lowerPart.SetTransform(posClone, lowerAngle-Settings.pihalve);

            const endJointPosRotated = rotateVectorAroundPoint(new Box2D.b2Vec2(lowerJointPos.x-lowerLength, lowerJointPos.y), lowerJointPos, lowerAngle*game.editor.RAD2DEG);
            endJointPos.x = endJointPosRotated.x;
            endJointPos.y = endJointPosRotated.y;
            endJoint.position.x = endJointPos.x*Settings.PTM;
            endJoint.position.y = endJointPos.y*Settings.PTM;
            Box2D.destroy(endJointPosRotated);

            const endPos = new Box2D.b2Vec2(endJointPos.x, endJointPos.y);
            // const offsetAngle = this.flipped ? Math.PI-endPart.jointOffsetAngle+this.lookupObject.body.GetAngle() : Math.PI-endPart.jointOffsetAngle-this.lookupObject.body.GetAngle();

            let targetOffsetAngle = this.flipped ? lowerAngle - endPart.jointOffsetAngle+Settings.pihalve : lowerAngle + endPart.jointOffsetAngle-Settings.pihalve;
            endPos.set_x(endPos.get_x() + endPart.jointOffsetLength * Math.cos(targetOffsetAngle));
            endPos.set_y(endPos.get_y() + endPart.jointOffsetLength * Math.sin(targetOffsetAngle));

            endPart.SetTransform(endPos, lowerAngle-Settings.pihalve);
        }
    }

    calculateJointOffsets(){
        [Humanoid.BODY_PARTS.HAND_LEFT, Humanoid.BODY_PARTS.HAND_RIGHT, Humanoid.BODY_PARTS.FEET_LEFT, Humanoid.BODY_PARTS.FEET_RIGHT].forEach(part => {
            const joint = this.lookupObject[part+"_joint"];
            const jointWorldPos = vec1;
            jointWorldPos.Set(joint.position.x / Settings.PTM, joint.position.y / Settings.PTM);
            const bodyPart = this.lookupObject[part];
            const jointOffset = vec2;
            jointOffset.Set(bodyPart.GetPosition().x, bodyPart.GetPosition().y);
            b2SubVec2(jointOffset, jointWorldPos);
            bodyPart.jointOffsetAngle = Math.atan2(jointOffset.y, jointOffset.x) - this.lookupObject.body.GetAngle();
            bodyPart.jointOffsetLength = jointOffset.Length();
        });
    }
}

PrefabManager.prefabLibrary.Humanoid = {
    class: Humanoid,
}
